import React, { Component } from 'react'

class projects extends Component {
    render() {
        return (
            <div>
                Projects
            </div>
        )
    }
}

export default projects



// WEBPACK FOOTER //
// ./src/components/layout/projects.js